import { createContext } from 'react';

export const ExperimentContext = createContext({
  isExperimentReady: false,
});

export const ExperimentsProvider = ExperimentContext.Provider;
